import { render, staticRenderFns } from "./StagingRelatedDocForm.vue?vue&type=template&id=2d33efd0"
import script from "./StagingRelatedDocForm.vue?vue&type=script&lang=ts"
export * from "./StagingRelatedDocForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports